import { defineAction } from '~/prix'
import { z } from 'zod'
import bullDeleteAction from './bullDelete.action.json' with { type: 'json' }
import { bullObject } from '../bullObject'

const bullDeleteDefinition = defineAction({
  ...bullDeleteAction,

  input: z.object({ id: bullObject.shape.id }),
  output: z.object({}),
})

export default bullDeleteDefinition
